module.exports = __webpack_public_path__ + "static/media/bedside.b71d85d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/bedside.jpg
// module id = 13894
// module chunks = 0